module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cassiopeia/cas_border-dc65689201319bf7c8f633c0898624ab.gif";